/* SansMinds — shared storefront behaviors. No dependencies.
   Each initializer is idempotent (guards via dataset flags) and re-runs on
   Shopify's section:load event so it works inside the theme editor. */
(function () {
  'use strict';

  /* --- Carousel: prev/next scroll one tile at a time (drops, quotes) --- */
  function initCarousel(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = '1';
    var track = root.querySelector('[data-carousel-track]');
    var section = root.closest('section') || document;
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (!track) return;
    function step() {
      var first = track.querySelector(':scope > *');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '24') || 24;
      return first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* --- Countdown: ticks a [data-countdown="ISO"] element to zero --- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickCountdown(el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var diff = Math.floor((target - Date.now()) / 1000);
    if (diff < 0) diff = 0;
    var hh = Math.floor(diff / 3600), mm = Math.floor((diff % 3600) / 60), ss = diff % 60;
    var h = el.querySelector('[data-hh]'), m = el.querySelector('[data-mm]'), s = el.querySelector('[data-ss]');
    if (h) h.textContent = pad(hh);
    if (m) m.textContent = pad(mm);
    if (s) s.textContent = pad(ss);
  }
  function initCountdown(el) {
    if (el.dataset.cdReady) return;
    el.dataset.cdReady = '1';
    tickCountdown(el);
    setInterval(function () { tickCountdown(el); }, 1000);
  }

  /* --- Product gallery: thumbnail swaps the main image --- */
  function initGallery(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = '1';
    var main = root.querySelector('[data-gallery-main]');
    if (!main) return;
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) { main.src = full; main.srcset = ''; }
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* --- Quantity stepper --- */
  function initQty(root) {
    if (root.dataset.qtyReady) return;
    root.dataset.qtyReady = '1';
    var input = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (!input) return;
    function clamp(v) { var min = parseInt(input.min || '1', 10); return isNaN(v) || v < min ? min : v; }
    if (minus) minus.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) + 1); });
  }

  /* --- Preselect a <select data-default> (saved country on address edit) --- */
  function initDefaultSelect(sel) {
    if (sel.dataset.defReady) return;
    sel.dataset.defReady = '1';
    var val = sel.getAttribute('data-default');
    if (val) sel.value = val;
  }

  /* --- Confirm before submitting a destructive form [data-confirm] --- */
  function initConfirmForm(form) {
    if (form.dataset.confirmReady) return;
    form.dataset.confirmReady = '1';
    form.addEventListener('submit', function (e) {
      if (!window.confirm(form.getAttribute('data-confirm'))) e.preventDefault();
    });
  }

  function initAll(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-carousel]').forEach(initCarousel);
    s.querySelectorAll('[data-countdown]').forEach(initCountdown);
    s.querySelectorAll('[data-gallery]').forEach(initGallery);
    s.querySelectorAll('[data-qty]').forEach(initQty);
    s.querySelectorAll('select[data-default]').forEach(initDefaultSelect);
    s.querySelectorAll('form[data-confirm]').forEach(initConfirmForm);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
